import { render, staticRenderFns } from "./lecturerLabel.vue?vue&type=template&id=3e4c44e0&scoped=true"
import script from "./lecturerLabel.vue?vue&type=script&lang=js"
export * from "./lecturerLabel.vue?vue&type=script&lang=js"
import style0 from "./lecturerLabel.vue?vue&type=style&index=0&id=3e4c44e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4c44e0",
  null
  
)

export default component.exports